var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 5.25C19.1168 5.25 19.875 6.084 19.875 7.11675V18.7568C19.875 19.7865 19.1175 20.6239 18.18 20.6239H2.8185C1.884 20.6239 1.125 19.7869 1.125 18.7568V6.85087C1.125 5.81812 1.8825 5.24887 2.8185 5.24887",
    fill: "#6387E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84761 3C7.16336 3 7.41949 3.28125 7.41949 3.63L11.1695 7.64587C11.1695 7.99312 10.913 8.27512 10.5976 8.27512H1.69586C1.38086 8.27512 1.12549 7.99312 1.12549 7.64587V3.63C1.12549 3.28125 1.38124 3 1.69586 3H6.84761Z",
    fill: "#6387E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1537 8.604C22.0897 8.604 22.848 9.438 22.848 10.4708L20.2354 18.7582C19.9504 19.5004 19.1029 20.6254 18.1654 20.6254H2.8185C1.884 20.6254 1.125 19.7884 1.125 18.7582L3.73837 10.4708C4.125 9.75 4.87087 8.604 5.80687 8.604",
    fill: "#D6E1FD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolder);
export default __webpack_public_path__ + "static/media/open-folder.914dd6a76d25a671179feeed9c80b90f.svg";
export { ForwardRef as ReactComponent };